module.exports = __webpack_public_path__ + "img/round-error-symbol.3400f652.svg";